"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8343],{

/***/ 78599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FactoryQueryParams; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50853);
/* harmony import */ var _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24880);




var FactoryQueryParams = /*#__PURE__*/ function() {
    "use strict";
    function FactoryQueryParams(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, FactoryQueryParams);
        this.config = config;
    }
    var _proto = FactoryQueryParams.prototype;
    _proto.params = function params() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
            var isNode, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__/* .Environment.create */ .q.create().isNode();
                        if (!isNode) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 536).then(__webpack_require__.t.bind(__webpack_require__, 30536, 23))
                        ];
                    case 1:
                        _tmp = _state.sent().NodeQueryParams.create({
                            config: _this.config
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 877).then(__webpack_require__.bind(__webpack_require__, 20877))
                        ];
                    case 3:
                        _tmp = _state.sent().WindowQueryParams.create({
                            config: _this.config
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    FactoryQueryParams.create = function create(param) {
        var config = param.config;
        return new FactoryQueryParams(config);
    };
    return FactoryQueryParams;
}();


/***/ }),

/***/ 8343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GetCurrentSourceSharedUseCase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50853);
/* harmony import */ var _infrastructure_QueryParamSharedRepository__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86778);




var GetCurrentSourceSharedUseCase = /*#__PURE__*/ function() {
    "use strict";
    function GetCurrentSourceSharedUseCase(repository) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GetCurrentSourceSharedUseCase);
        this.repository = repository;
    }
    var _proto = GetCurrentSourceSharedUseCase.prototype;
    _proto.execute = function execute() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                return [
                    2,
                    _this.repository.source()
                ];
            });
        })();
    };
    GetCurrentSourceSharedUseCase.create = function create(param) {
        var config = param.config, repository = param.repository;
        return new GetCurrentSourceSharedUseCase(repository !== null && repository !== void 0 ? repository : _infrastructure_QueryParamSharedRepository__WEBPACK_IMPORTED_MODULE_0__/* .QueryParamSharedRepository.create */ .K.create({
            config: config
        }));
    };
    return GetCurrentSourceSharedUseCase;
}();
GetCurrentSourceSharedUseCase.USE_CASE_NAME = "GetCurrentSourceSharedUseCase";



/***/ }),

/***/ 83760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ ListOfPax; }
});

// UNUSED EXPORTS: ListOfPaxValidation

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/zod/v3/types.js + 1 modules
var types = __webpack_require__(53538);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/architecture.ts
var architecture = __webpack_require__(70163);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/domain/Pax.ts






var PaxValidation = types/* object */.Ry({
    adults: types/* number */.Rx({
        message: "adults is required"
    }),
    children: types/* number */.Rx({
        message: "children is required"
    }).array()
});
var Pax = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(Pax, Model);
    var _super = (0,_create_super/* default */.Z)(Pax);
    function Pax(_adults, _children) {
        (0,_class_call_check/* default */.Z)(this, Pax);
        var _this;
        _this = _super.call(this);
        _this._adults = _adults;
        _this._children = _children;
        return _this;
    }
    var _proto = Pax.prototype;
    _proto.toJSON = function toJSON() {
        return {
            adults: this.adults,
            children: this.children
        };
    };
    Pax.create = function create(param) {
        var adults = param.adults, children = param.children;
        PaxValidation.parse({
            adults: adults,
            children: children
        });
        return new Pax(adults, children);
    };
    Pax.defaultPax = function defaultPax() {
        return Pax.create({
            adults: 2,
            children: []
        });
    };
    (0,_create_class/* default */.Z)(Pax, [
        {
            key: "adults",
            get: function get() {
                return this._adults;
            } // prettier-ignore
        },
        {
            key: "children",
            get: function get() {
                return this._children;
            } // prettier-ignore
        }
    ]);
    return Pax;
}(architecture/* Model */.H);

;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/domain/ListOfPax.ts







var ListOfPaxValidation = types/* object */.Ry({
    list: types/* instanceof */.Pp(Pax, {
        message: "list is required"
    }).array()
});
var ListOfPax = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(ListOfPax, Model);
    var _super = (0,_create_super/* default */.Z)(ListOfPax);
    function ListOfPax(_list) {
        (0,_class_call_check/* default */.Z)(this, ListOfPax);
        var _this;
        _this = _super.call(this);
        _this._list = _list;
        return _this;
    }
    var _proto = ListOfPax.prototype;
    _proto.toJSON = function toJSON() {
        return {
            list: this._list.map(function(item) {
                return item.toJSON();
            })
        };
    };
    ListOfPax.create = function create(param) {
        var list = param.list;
        ListOfPaxValidation.parse({
            list: list
        });
        return new ListOfPax(list);
    };
    ListOfPax.default = function _default() {
        return ListOfPax.create({
            list: [
                Pax.defaultPax()
            ]
        });
    };
    ListOfPax.fromQueryParams = function fromQueryParams(param) {
        var adults = param.adults, children = param.children;
        var adultsArray = adults.split(",").filter(Boolean);
        var childrenArray = children === null || children === void 0 ? void 0 : children.split("!").filter(Boolean);
        var ref;
        var list = adultsArray.map(function(adult, index) {
            var ref1;
            return Pax.create({
                adults: Number(adult),
                children: (ref = childrenArray === null || childrenArray === void 0 ? void 0 : (ref1 = childrenArray[index]) === null || ref1 === void 0 ? void 0 : ref1.split(",").map(Number)) !== null && ref !== void 0 ? ref : []
            });
        });
        return ListOfPax.create({
            list: list
        });
    };
    ListOfPax.empty = function empty() {
        return new ListOfPax([]);
    };
    (0,_create_class/* default */.Z)(ListOfPax, [
        {
            key: "list",
            get: function get() {
                return this._list;
            } // prettier-ignore
        }
    ]);
    return ListOfPax;
}(architecture/* Model */.H);


/***/ }),

/***/ 60563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ PartialSearch; }
/* harmony export */ });
/* unused harmony export PartialSearchValidation */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27805);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58408);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53538);
/* harmony import */ var _kernel_Date__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83209);
/* harmony import */ var _kernel_architecture__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70163);
/* harmony import */ var _ListOfPax__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83760);








var PartialSearchValidation = zod__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry({
    checkIn: zod__WEBPACK_IMPORTED_MODULE_2__/* ["instanceof"] */ .Pp(_kernel_Date__WEBPACK_IMPORTED_MODULE_0__/* .DateModel */ .rV, {
        message: "checkIn is required"
    }),
    checkOut: zod__WEBPACK_IMPORTED_MODULE_2__/* ["instanceof"] */ .Pp(_kernel_Date__WEBPACK_IMPORTED_MODULE_0__/* .DateModel */ .rV, {
        message: "checkOut is required"
    }),
    paxes: zod__WEBPACK_IMPORTED_MODULE_2__/* ["instanceof"] */ .Pp(_ListOfPax__WEBPACK_IMPORTED_MODULE_1__/* .ListOfPax */ .o, {
        message: "paxes is required"
    })
});
var PartialSearch = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PartialSearch, Model);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PartialSearch);
    function PartialSearch(_checkIn, _checkOut, _paxes) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PartialSearch);
        var _this;
        _this = _super.call(this);
        _this._checkIn = _checkIn;
        _this._checkOut = _checkOut;
        _this._paxes = _paxes;
        return _this;
    }
    var _proto = PartialSearch.prototype;
    _proto.toJSON = function toJSON() {
        return {
            checkIn: this.checkIn,
            checkOut: this.checkOut,
            paxes: this.paxes.toJSON().list
        };
    };
    PartialSearch.create = function create(param) {
        var checkIn = param.checkIn, checkOut = param.checkOut, paxes = param.paxes;
        PartialSearchValidation.parse({
            checkIn: checkIn,
            checkOut: checkOut,
            paxes: paxes
        });
        return new PartialSearch(checkIn, checkOut, paxes);
    };
    PartialSearch.default = function _default() {
        var today = new __webpack_require__.g.Date();
        var threeDaysLater = new __webpack_require__.g.Date(today);
        threeDaysLater.setDate(today.getDate() + 3);
        return new PartialSearch(_kernel_Date__WEBPACK_IMPORTED_MODULE_0__/* .DateModel.fromGlobalDate */ .rV.fromGlobalDate(today), _kernel_Date__WEBPACK_IMPORTED_MODULE_0__/* .DateModel.fromGlobalDate */ .rV.fromGlobalDate(threeDaysLater), _ListOfPax__WEBPACK_IMPORTED_MODULE_1__/* .ListOfPax["default"] */ .o["default"]());
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(PartialSearch, [
        {
            key: "checkIn",
            get: function get() {
                return this._checkIn.value;
            } // prettier-ignore
        },
        {
            key: "checkOut",
            get: function get() {
                return this._checkOut.value;
            } // prettier-ignore
        },
        {
            key: "paxes",
            get: function get() {
                return this._paxes;
            } // prettier-ignore
        }
    ]);
    return PartialSearch;
}(_kernel_architecture__WEBPACK_IMPORTED_MODULE_7__/* .Model */ .H);


/***/ }),

/***/ 86778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ QueryParamSharedRepository; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/zod/v3/types.js + 1 modules
var types = __webpack_require__(53538);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/architecture.ts
var architecture = __webpack_require__(70163);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/domain/Source.ts






var ALLOWED_SOURCES = [
    "web",
    "meta",
    "email"
];
var SourceValidation = types/* object */.Ry({
    value: types/* enum */.Km(ALLOWED_SOURCES, {
        required_error: "value is required"
    })
});
var Source = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(Source, Model);
    var _super = (0,_create_super/* default */.Z)(Source);
    function Source(_value) {
        (0,_class_call_check/* default */.Z)(this, Source);
        var _this;
        _this = _super.call(this);
        _this._value = _value;
        return _this;
    }
    var _proto = Source.prototype;
    _proto.isEmpty = function isEmpty() {
        return !this._value;
    };
    _proto.isFilled = function isFilled() {
        return !!this._value;
    };
    _proto.isDefault = function isDefault() {
        return this._value === Source.DEFAULT_SOURCE;
    };
    _proto.isNotDefault = function isNotDefault() {
        return this._value !== Source.DEFAULT_SOURCE;
    };
    _proto.toJSON = function toJSON() {
        var __value;
        return {
            value: (__value = this._value) !== null && __value !== void 0 ? __value : null
        };
    };
    Source.create = function create(param) {
        var value = param.value;
        SourceValidation.parse({
            value: value
        });
        return new Source(value);
    };
    Source.createOrEmpty = function createOrEmpty(param) {
        var value = param.value;
        try {
            return Source.create({
                value: value
            });
        } catch (e) {
            return Source.empty();
        }
    };
    Source.empty = function empty() {
        return new Source();
    };
    (0,_create_class/* default */.Z)(Source, [
        {
            key: "value",
            get: function get() {
                return this._value;
            }
        }
    ]);
    return Source;
}(architecture/* Model */.H);
Source.DEFAULT_SOURCE = "web";

// EXTERNAL MODULE: ../../packages/stayforlong/src/_queryparams/FactoryQueryParams.ts
var FactoryQueryParams = __webpack_require__(78599);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Market.ts
var Market = __webpack_require__(14828);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Language.ts
var Language = __webpack_require__(43491);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ErrorsCode.ts
var ErrorsCode = __webpack_require__(65694);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/DomainError.ts
var DomainError = __webpack_require__(11455);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Date.ts
var _kernel_Date = __webpack_require__(83209);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/ListOfPax.ts + 1 modules
var ListOfPax = __webpack_require__(83760);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/PartialSearch.ts
var PartialSearch = __webpack_require__(60563);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/shared/infrastructure/QueryParamSharedRepository.ts













var QueryParamSharedRepository = /*#__PURE__*/ function() {
    "use strict";
    function QueryParamSharedRepository(config) {
        (0,_class_call_check/* default */.Z)(this, QueryParamSharedRepository);
        this.config = config;
    }
    var _proto = QueryParamSharedRepository.prototype;
    _proto.market = function market() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var params, ref, error, market;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryQueryParams/* FactoryQueryParams.create */.R.create({
                                config: _this.config
                            }).params()
                        ];
                    case 1:
                        params = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: QueryParamSharedRepository.MARKET_QUERY_PARAMS
                        }), 2), error = ref[0], market = ref[1];
                        if (error) return [
                            2,
                            Market/* Market.empty */.IY.empty()
                        ];
                        return [
                            2,
                            Market/* Market.createOrEmpty */.IY.createOrEmpty({
                                value: market
                            })
                        ];
                }
            });
        })();
    };
    _proto.language = function language() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var params, ref, error, language;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryQueryParams/* FactoryQueryParams.create */.R.create({
                                config: _this.config
                            }).params()
                        ];
                    case 1:
                        params = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: QueryParamSharedRepository.QUERY_PARAM_LANGUAGE
                        }), 2), error = ref[0], language = ref[1];
                        if (error) return [
                            2,
                            Language/* Language.empty */.S.empty()
                        ];
                        return [
                            2,
                            Language/* Language.createOrEmpty */.S.createOrEmpty({
                                value: language
                            })
                        ];
                }
            });
        })();
    };
    _proto.partialSearch = function partialSearch() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var params, ref, errorCheckIn, checkIn, ref1, errorCheckOut, checkOut, ref2, errorAdults, adults, ref3, errorChildren, children;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryQueryParams/* FactoryQueryParams.create */.R.create({
                                config: _this.config
                            }).params()
                        ];
                    case 1:
                        params = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: "checkIn",
                            options: {
                                caseSensitive: false
                            }
                        }), 2), errorCheckIn = ref[0], checkIn = ref[1];
                        ref1 = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: "checkOut",
                            options: {
                                caseSensitive: false
                            }
                        }), 2), errorCheckOut = ref1[0], checkOut = ref1[1];
                        ref2 = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: "adults"
                        }), 2), errorAdults = ref2[0], adults = ref2[1];
                        ref3 = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: "children",
                            options: {
                                required: false
                            }
                        }), 2), errorChildren = ref3[0], children = ref3[1];
                        if (errorCheckIn || errorCheckOut || errorAdults || errorChildren) {
                            return [
                                2,
                                PartialSearch/* PartialSearch.default */.u["default"]()
                            ];
                        }
                        return [
                            2,
                            PartialSearch/* PartialSearch.create */.u.create({
                                checkIn: _kernel_Date/* DateModel.create */.rV.create({
                                    value: checkIn
                                }),
                                checkOut: _kernel_Date/* DateModel.create */.rV.create({
                                    value: checkOut
                                }),
                                paxes: ListOfPax/* ListOfPax.fromQueryParams */.o.fromQueryParams({
                                    adults: adults,
                                    children: children
                                })
                            })
                        ];
                }
            });
        })();
    };
    _proto.affiliate = function affiliate() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.source = function source() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var params, ref, error, source;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryQueryParams/* FactoryQueryParams.create */.R.create({
                                config: _this.config
                            }).params()
                        ];
                    case 1:
                        params = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(params.getByQuery({
                            query: QueryParamSharedRepository.QUERY_PARAM_SOURCE
                        }), 2), error = ref[0], source = ref[1];
                        if (error) return [
                            2,
                            Source.empty()
                        ];
                        return [
                            2,
                            Source.createOrEmpty({
                                value: source
                            })
                        ];
                }
            });
        })();
    };
    _proto.featureFlagByName = function featureFlagByName() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    QueryParamSharedRepository.create = function create(param) {
        var config = param.config;
        return new QueryParamSharedRepository(config);
    };
    return QueryParamSharedRepository;
}();
QueryParamSharedRepository.MARKET_QUERY_PARAMS = "market";
QueryParamSharedRepository.QUERY_PARAM_LANGUAGE = "lang";
QueryParamSharedRepository.QUERY_PARAM_SOURCE = "source";


/***/ })

}]);